var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "924 2869 101.536 112.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1ea6c6;\n      }\n\n      .cls-2 {\n        fill: #fcd09f;\n      }\n\n      .cls-3 {\n        fill: #ef806f;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove-user",
    transform: "translate(900.247 2869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(23.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    className: "cls-1",
    d: "M71.753,229.286c0,5.868.91,10.484,4,15a60.62,60.62,0,0,1-52-15h0c0-16.474,10.056-30.363,24-37,5.241,5.227,10.634,8,17,8s12.757-2.773,18-8a42.11,42.11,0,0,1,12,9C81.382,203.455,71.753,215.311,71.753,229.286Z",
    transform: "translate(-23.753 -140.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    className: "cls-2",
    d: "M114.546,0a23.1,23.1,0,0,1,23,23c0,12.627-10.376,30-23,30s-23-17.373-23-30A23.1,23.1,0,0,1,114.546,0Z",
    transform: "translate(-73.546)"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    className: "cls-3",
    cx: 24.768,
    cy: 24.098,
    rx: 24.768,
    ry: 24.098,
    transform: "translate(75.753 64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    className: "cls-4",
    width: 34.123,
    height: 4.537,
    transform: "translate(111.071 101.719) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    className: "cls-4",
    width: 34.123,
    height: 4.537,
    transform: "translate(86.943 98.511) rotate(-45)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveUser);
export default __webpack_public_path__ + "static/media/remove-user.604ce6acde3cfdfdd1846873f4ade5ad.svg";
export { ForwardRef as ReactComponent };